<template>
  <div queue-auth-hook class="auth" :class="{'auth_show':visibleAuthForm}">
    <div queue-auth-target-hook @click="showAuthForm" class="auth__target"></div>
    <div class="auth__box">
      <div queue-auth-overlay-hook class="auth__overlay" @click="hideAuthForm"></div>
      <div class="auth__form">
        <AuthForm
          :logout="sessionInit"
          :reset="resetAuthForm"
          :loading="loadingGui"
          :error-submit="errorSubmit"
          @login="auth"
          @logout="logout"
          @close="hideAuthForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import AuthController from './auth-controller'

  // components
  import AuthForm from '@/components/forms/auth/AuthForm'

  export default {
    name: 'Auth',
    mixins: [AuthController],
    components: {
      AuthForm
    }
  }
</script>
